<template>
    <div class="headerWarp">
        <div class="header" id="top">
            <div class="logo fl">
                <img src="@/assets/UniversityLogo.png" alt="">
            </div>
            <div class="til fl">内蒙古基层治理大数据平台</div>
            <div class="tabLi fl">
                <ul>
                    <li><router-link to="/">首页</router-link></li>
                    <li><router-link to="/newHome/news">新闻资讯</router-link></li>
                    <li><a @click="goDataIndex">指数中心</a></li>
                    <li><router-link to='/newHome/measure'>政策措施</router-link></li>
                    <li><router-link to="/newHome/paper">电子期刊</router-link></li>
                </ul>
            </div>
            <div class="loginBtn fr" v-if="!sid"><span @click="visible = !visible">登录/注册</span></div>
            <div class="loginBtn fr" v-else>
                <span>{{ realName }},<span @click="logOut">退出</span></span>
            </div>
        </div>
        <Login :visible="visible" @close="closeModal"></Login>
    </div>
</template>

<script>
import { getCookie, delCookie,messageTips,setCookie} from "@/until/tools";
import Login from "@/components/Login_modal.vue";
export default {
    components:{Login,},
    data() {
        return {
            sid:getCookie('bd_sid') ||'',
            visible:false,
            realName:''
        };
    },

    mounted() {
        this.getUserInfo()
    },

    methods: {
        goDataIndex(e){
            if(this.sid){
                this.$router.push('/newHome/dataIndex')
            }else{
                this.visible = true
            }
        },
        logOut() {
            setCookie('loginTargetUrl',this.$route.path,{time:1});
            this.sid = "";
            delCookie("bd_sid");
            console.log(this.sid);
        },
        closeModal(){
            this.visible = false;
            this.sid = getCookie('bd_sid');
            this.getUserInfo();
        },
        getUserInfo(){
            this.$http.getUserInfo().then(res=>{
                if(res.success){
                    this.realName = res.userInfo.realName;
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.fr{
    float: right;
}
.fl{
    float: left;
}
.headerWarp {
    background: #0F5743;
    color: #fff;

    .header {
        height: 80px;
        width: 1200px;
        margin: 0 auto;
        line-height: 80px;
        overflow: hidden;

        .logo {
            width: 53px;
            height: 53px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .til{
        margin-left:20px;
        font-size:20px;
    }
    .tabLi {
        font-size: 14px;
        margin-left: 143px;
        margin-bottom: 0px;

        ul {
            display: flex;

            li:not(:nth-child(1)) {
                margin-left: 40px;
            }

            li {
                list-style-type: none;
                font-size:16px;
                cursor: pointer;

                a {
                    color: #fff;
                }
            }
        }
    }

    .loginBtn {
        font-size: 14px;
        cursor: pointer;
    }
}</style>